import { Component  } from "react";
import AboutPage from "../Components/AboutPage/AboutPage";
import { globals, traceView } from "../Components/Globals/Globals";

class AboutPageView extends Component{
    constructor(props){
        super(props)

        traceView("AboutPageView");
    }

    render(){
        return(
            <>
              <AboutPage/>  
            </>
        )
    }
}

export default AboutPageView;